export enum HrefType {
  ANGULAR_ROUTE = 'angularRoute',
  OPEN_FLYOUT = 'openFlyout',
  EXTERNAL = 'externalLink',
  OPEN_MODAL_VIDEO = 'openModalVideo',
}
